import { useRouter } from 'next/router';
import Logo from 'components/v2/atoms/logo';
import NavMenu from 'components/v2/modules/about-lp/nav-menu';

const AboutPageHeader = () => {
  const router = useRouter();
  const currentPath = router.pathname;
  return (
    <header
      className={`all-font-sans border-line-sen sticky top-0 z-50 w-full border-b bg-white transition-all duration-300`}
    >
      <div className="mx-auto max-w-screen-xl p-5 lg:px-10">
        <div className="flex items-center justify-between">
          <Logo href="/" />
          <NavMenu currentPath={currentPath} />
        </div>
      </div>
    </header>
  );
};

export default AboutPageHeader;
